import axios from 'axios'
import {
    TABLE_LIST_REQUEST,
    TABLE_LIST_SUCCESS,
    TABLE_LIST_FAIL,
    TABLE_DETAILS_REQUEST,
    TABLE_DETAILS_SUCCESS,
    TABLE_DETAILS_FAIL,
    TABLE_CREATE_REQUEST,
    TABLE_CREATE_SUCCESS,
    TABLE_CREATE_FAIL,
    TABLE_UPDATE_REQUEST,
    TABLE_UPDATE_SUCCESS,
    TABLE_UPDATE_FAIL,
    TABLE_DELETE_REQUEST,
    TABLE_DELETE_SUCCESS,
    TABLE_DELETE_FAIL,
} from '../constants/tableConstants'
import { logout } from './userActions'

let API_URL = process.env.REACT_APP_API_URL || 'https://localhost:5000'

// Remove trailing /api or slash if present
if (API_URL.endsWith('/api')) {
    API_URL = API_URL.slice(0, -4)
}
if (API_URL.endsWith('/')) {
    API_URL = API_URL.slice(0, -1)
}

export const listTables =
    ({ clubId, page = 1, limit = 20 }) =>
        async (dispatch, getState) => {
            try {
                dispatch({ type: TABLE_LIST_REQUEST })

                const {
                    userLogin: { userInfo },
                    adminLogin: { userInfo: adminInfo },
                } = getState()

                const token = userInfo?.token || adminInfo?.token

                const config = {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }

                let queryStr = `?page=${page}&limit=${limit}`
                if (clubId) queryStr += `&clubId=${clubId}`

                const { data } = await axios.get(`${API_URL}/api/tables${queryStr}`, config)

                dispatch({
                    type: TABLE_LIST_SUCCESS,
                    payload: data,
                })
            } catch (error) {
                const message =
                    error.response && error.response.data.message
                        ? error.response.data.message
                        : error.message
                if (message === 'Not authorized, token failed') {
                    dispatch(logout())
                }
                dispatch({
                    type: TABLE_LIST_FAIL,
                    payload: message,
                })
            }
        }

export const listTableDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: TABLE_DETAILS_REQUEST })

        const {
            userLogin: { userInfo },
            adminLogin: { userInfo: adminInfo },
        } = getState()

        const token = userInfo?.token || adminInfo?.token

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        const { data } = await axios.get(`${API_URL}/api/tables/${id}`, config)

        dispatch({
            type: TABLE_DETAILS_SUCCESS,
            payload: data,
        })
    } catch (error) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }
        dispatch({
            type: TABLE_DETAILS_FAIL,
            payload: message,
        })
    }
}

export const createTable = (tableData) => async (dispatch, getState) => {
    try {
        dispatch({ type: TABLE_CREATE_REQUEST })

        const {
            userLogin: { userInfo },
            adminLogin: { userInfo: adminInfo },
        } = getState()

        const token = userInfo?.token || adminInfo?.token

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        const { data } = await axios.post(`${API_URL}/api/tables`, tableData, config)

        dispatch({
            type: TABLE_CREATE_SUCCESS,
            payload: data,
        })
    } catch (error) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }
        dispatch({
            type: TABLE_CREATE_FAIL,
            payload: message,
        })
    }
}

export const updateTable = (table) => async (dispatch, getState) => {
    try {
        dispatch({ type: TABLE_UPDATE_REQUEST })

        const {
            userLogin: { userInfo },
            adminLogin: { userInfo: adminInfo },
        } = getState()

        const token = userInfo?.token || adminInfo?.token

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        }

        const { data } = await axios.put(
            `${API_URL}/api/tables/${table._id}`,
            table,
            config
        )

        dispatch({
            type: TABLE_UPDATE_SUCCESS,
            payload: data,
        })
    } catch (error) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }
        dispatch({
            type: TABLE_UPDATE_FAIL,
            payload: message,
        })
    }
}

export const deleteTable = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: TABLE_DELETE_REQUEST })

        const {
            userLogin: { userInfo },
            adminLogin: { userInfo: adminInfo },
        } = getState()

        const token = userInfo?.token || adminInfo?.token

        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        await axios.delete(`${API_URL}/api/tables/${id}`, config)

        dispatch({
            type: TABLE_DELETE_SUCCESS,
        })
    } catch (error) {
        const message =
            error.response && error.response.data.message
                ? error.response.data.message
                : error.message
        if (message === 'Not authorized, token failed') {
            dispatch(logout())
        }
        dispatch({
            type: TABLE_DELETE_FAIL,
            payload: message,
        })
    }
}
